import { render, staticRenderFns } from "./AplicarCoberturas.vue?vue&type=template&id=5ed86057&scoped=true"
import script from "./AplicarCoberturas.vue?vue&type=script&lang=js"
export * from "./AplicarCoberturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed86057",
  null
  
)

export default component.exports